import {Injectable} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
import {AuthenticatedUser} from "../dm";
import jwtDecode from "jwt-decode";
import {EmailVerificationService} from "./email-verification.service";
import {LoggerService} from "./logger.service";

@Injectable()
export class AuthService {
  constructor(
    private readonly emailVerificationService: EmailVerificationService,
    private readonly log: LoggerService
  ) { }

  private readonly authTokenSubject = new BehaviorSubject<undefined|string>(undefined)
  readonly authToken$ = this.authTokenSubject.asObservable()

  private readonly userSubject = new BehaviorSubject<undefined|AuthenticatedUser>(undefined)
  readonly user$ = this.userSubject.asObservable()

  private readonly reauthenticatedSubject = new Subject<void>()
  readonly reauthenticated$ = this.reauthenticatedSubject.asObservable()

  updateToken(newToken: string) {
    this.authTokenSubject.next(newToken)

    // Clear email verification warning if the new token shows email is verified
    try {
      const decoded: any = jwtDecode(newToken)
      if (decoded?.email_verified === true) {
        this.emailVerificationService.clearVerificationRequired()
      }
    } catch (e) {
      this.log.warn("Failed to decode idToken for email verification check", e)
    }
  }

  updateUser(user: AuthenticatedUser) {
    this.userSubject.next(user)
  }

  notifyReauthenticated(): void {
    this.reauthenticatedSubject.next()
  }
}
